'use client';

import Link from 'next/link';

export function SkipLink() {
  return (
    <Link
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:rounded-full focus:bg-pb-blue-600 focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-pb-white focus:outline-none focus:ring-2 focus:ring-pb-white"
    >
      Skip to content
    </Link>
  );
}
